import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function ImageSlider() {
    let settings = {
        dots: true,
        infinite: true,
        autoplay: true,
  autoplaySpeed: 2000,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        cssEase: "linear",
        responsive: [{
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
             breakpoint: 400,
             settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
             }
          }]
    }
    return (
        <Slider {...settings}>


   <div className="card-wrapper">
                <div className="card">
                    <div className="card-image">
                        <img className="img-responsive" src="../img/activites/athletisme/athletisme3.jpg"  alt="" />
                    </div>
                    <div className="details">
                    </div>
            </div>
   </div>

   <div className="card-wrapper">
                <div className="card">
                    <div className="card-image">
                        <img className="img-responsive" src="../img/activites/athletisme/athletisme4.jpg"  alt="" />
                    </div>
                    <div className="details">
                    </div>
            </div>
   </div>


   <div className="card-wrapper">
                <div className="card">
                    <div className="card-image">
                        <img className="img-responsive" src="../img/activites/athletisme/athletisme8.jpg"  alt="" />
                    </div>
                    <div className="details">
                    </div>
            </div>
   </div>

   <div className="card-wrapper">
                <div className="card">
                    <div className="card-image">
                        <img className="img-responsive" src="../img/activites/athletisme/athletisme9.jpg"  alt="" />
                    </div>
                    <div className="details">
                    </div>
            </div>
   </div>

        </Slider>
    )
}

export default ImageSlider